'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../../utils/utils');

var _consts = require('../consts');

var _wixAppsApi = require('./wixAppsApi');

var _wixAppsApi2 = _interopRequireDefault(_wixAppsApi);

var _upgradeToBusinessPopup = require('../checkout/popupMessage/upgradeToBusinessPopup');

var _upgradeToBusinessPopup2 = _interopRequireDefault(_upgradeToBusinessPopup);

var _experimentsWrapper = require('@wix/photography-client-lib/dist/src/sdk/experimentsWrapper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutHandler = function () {
  function CheckoutHandler(baseUrl) {
    (0, _classCallCheck3.default)(this, CheckoutHandler);

    this.baseUrl = baseUrl;
    this.checkoutParams = null;
    this.popupParams = {
      businessPlanUrl: null
    };
  }

  (0, _createClass3.default)(CheckoutHandler, [{
    key: 'getCheckoutData',
    value: function getCheckoutData() {
      return this.checkoutParams;
    }
  }, {
    key: 'setCheckoutData',
    value: function setCheckoutData(data) {
      this.checkoutParams = data;
    }
  }, {
    key: 'handleCheckoutRequest',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data, checkputParams) {
        var locale, additionalProviderParams, srcId, isAlbumStore, enableAlbumsStorePremiumValidation, isContainsDemoItems, shouldProceedToCheckout, appDefId, appsApi, _ref2, hasBusinessPackage, metaSiteId;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                locale = data.locale, additionalProviderParams = data.additionalProviderParams;
                srcId = additionalProviderParams.srcId, isAlbumStore = additionalProviderParams.isAlbumStore;
                enableAlbumsStorePremiumValidation = _experimentsWrapper.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.EnableAlbumsStorePremiumValidation');
                isContainsDemoItems = this.containsDemoItems(data);
                shouldProceedToCheckout = true;

                if (!isContainsDemoItems) {
                  _context.next = 10;
                  break;
                }

                this.openDemoItemsPopup(data);
                shouldProceedToCheckout = false;
                _context.next = 19;
                break;

              case 10:
                if (!(enableAlbumsStorePremiumValidation && isAlbumStore)) {
                  _context.next = 19;
                  break;
                }

                appDefId = isAlbumStore ? _consts.ALBUMS.ALBUMS_APP_DEF_ID : _consts.ART_STORE.ARTSTORE_APP_DEFINITION_ID;
                appsApi = _wixAppsApi2.default[appDefId];
                _context.next = 15;
                return appsApi.getSiteBusinessPackageData(locale, srcId, this.baseUrl);

              case 15:
                _ref2 = _context.sent;
                hasBusinessPackage = _ref2.hasBusinessPackage;
                metaSiteId = _ref2.metaSiteId;


                if (!hasBusinessPackage) {
                  this.popupParams.businessPlanUrl = appsApi.getSitebusinessPlanUrl(metaSiteId);

                  this.openBusinessPackagePopup(data);
                  shouldProceedToCheckout = false;
                }

              case 19:

                if (shouldProceedToCheckout) {
                  this.proceedToCheckout(data, checkputParams);
                }

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleCheckoutRequest(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return handleCheckoutRequest;
    }()
  }, {
    key: 'openDemoItemsPopup',
    value: function openDemoItemsPopup(data) {
      var isMobile = data.isMobile,
          storeApi = data.storeApi;

      var width = isMobile ? '100%' : 600;
      var height = isMobile ? '100%' : 300;
      var url = _utils.utils.generateUrl('checkout-popup-message.html');
      storeApi.openPopup(url, { width: width, height: height });
      data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CART, false);
    }
  }, {
    key: 'openBusinessPackagePopup',
    value: function openBusinessPackagePopup(data) {
      data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.STORE_POPUP_MESSAGE, true);
    }
  }, {
    key: 'proceedToCheckout',
    value: function proceedToCheckout(data, additionalParams) {
      this.setCheckoutData(additionalParams || {});
      data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CHECKOUT, true);
    }
  }, {
    key: 'containsDemoItems',
    value: function containsDemoItems(data) {
      var cartItems = data.cartItems;

      if (!cartItems) {
        return false;
      }
      var demoItems = cartItems.filter(function (item) {
        return item.isDemo;
      });
      return demoItems.length > 0;
    }
  }, {
    key: 'getCheckoutPopupMessage',
    value: function getCheckoutPopupMessage(data) {
      return this.getUpgradeToBusinessPopup(data);
    }
  }, {
    key: 'getUpgradeToBusinessPopup',
    value: function getUpgradeToBusinessPopup(data) {
      return _react2.default.createElement(
        'div',
        { className: 'artstore-popup-message-element-wrapper' },
        _react2.default.createElement(_upgradeToBusinessPopup2.default, {
          isMobile: data.isMobile,
          viewMode: data.viewMode,
          businessPlanUrl: this.popupParams.businessPlanUrl,
          closePopup: function closePopup() {
            return data.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.STORE_POPUP_MESSAGE, false);
          }
        })
      );
    }
  }]);
  return CheckoutHandler;
}();

exports.default = CheckoutHandler;